import $t from '../i18n'

export const ON_BOARDING_COMPLETE_TASK_REWARD = 5
export const PROMO_PERIOD_DAYS = 25
export const YEARS_TO_EXPIRE_HEALTH_HISTORY = 1
export const REWARD_PERIOD_DAYS = 7
export const TASKS_REQUIRED_TO_MVP = 2

export const DOWNLOAD_APP = {
  name: 'Download and sign in to the Antidote app',
  text: 'pages.mvpStatus.tasks.downloadApp',
}
export const COMPLETED_HEALTH_HISTORY = {
  name: 'Complete a short health history form',
  text: 'pages.mvpStatus.tasks.completeHealthHistory',
}
